import {
    IDirectBuyData,
    IDiscount,
    IDiscountPrices,
    IOrderSummary,
    IProductPricesWithDiscounts,
    ISkuPackage,
} from '@auth0spa/util/interfaces/ecommerce';
import { IParams } from '@auth0spa/util/interfaces/params';

export function buildOrderSummary(
    EnableEcommerceRobotUnits: boolean,
    EnableEcommercePromotionalDiscounts: boolean,
    directBuySkuInfo?: ISkuPackage,
    directBuySkuDiscount?: IDiscount,
    pricesWithDiscounts?: IProductPricesWithDiscounts,
    directBuyData?: IDirectBuyData,
) {
    if (EnableEcommerceRobotUnits && pricesWithDiscounts?.products) {
        let price = 0;
        let discountedPrice = 0;
        const currency = pricesWithDiscounts?.defaultCurrency ?? 'USD';
        let discount: IDiscountPrices | undefined;
        if (pricesWithDiscounts && directBuyData) {
            pricesWithDiscounts?.products.forEach(product => {
                const productQuantity = directBuyData.productQuantities[product.code];
                if (productQuantity) {
                    const quantity = productQuantity;
                    price += (quantity * product.prices[`${currency}`]);
                    if (product.discount && product.discount.couponId === directBuyData.discountCode) {
                        discountedPrice += (quantity * product.discount.discountedPrices[`${currency}`]);
                        discount = product.discount;
                    }
                }
            });
        }
        const shouldDisplayDiscount = EnableEcommercePromotionalDiscounts && !!discount;
        const orderSummary = {
            price,
            currency,
            shouldDisplayDiscount,
        } as IOrderSummary;
        if (shouldDisplayDiscount && discount) {
            orderSummary.discountedPrice = discountedPrice;
            orderSummary.percentageOff = discount.percentageOff;
            orderSummary.durationInMonths = discount.durationInMonths;
        }
        return orderSummary;
    }
    if (directBuySkuInfo) {
        const shouldDisplayDiscount = !!(EnableEcommercePromotionalDiscounts && directBuySkuDiscount);
        const orderSummary = {
            price: directBuySkuInfo.price,
            currency: directBuySkuInfo.currency,
            shouldDisplayDiscount,
        } as IOrderSummary;
        if (directBuySkuDiscount) {
            orderSummary.discountedPrice = directBuySkuDiscount?.discountedPrice;
            orderSummary.percentageOff = directBuySkuDiscount?.percentageOff;
            orderSummary.durationInMonths = directBuySkuDiscount?.durationInMonths;
        }
        return orderSummary;
    }
}

export function buildDirectBuyData(EnableEcommerceRobotUnits: boolean, params: IParams) {
    const data = { productQuantities: {} } as IDirectBuyData;
    if (EnableEcommerceRobotUnits) {
        if (params.db_discount) {
            data.discountCode = params.db_discount;
        }
        const {
            db_ru, db_unatt, db_attunu, db_ctzdevnu, db_rpadevpronu,
        } = params;
        if (db_ru) {
            data.productQuantities['RU'] = db_ru;
        }
        if (db_unatt) {
            data.productQuantities['UNATT'] = db_unatt;
        }
        if (db_attunu) {
            data.productQuantities['ATTUNU'] = db_attunu;
        }
        if (db_ctzdevnu) {
            data.productQuantities['CTZDEVNU'] = db_ctzdevnu;
        }
        if (db_rpadevpronu) {
            data.productQuantities['RPADEVPRONU'] = db_rpadevpronu;
        }
    }
    return data;
}

export function shouldUsePricesWithDiscountsUrl(EnableEcommerceRobotUnits: boolean, directBuyData?: IDirectBuyData) {
    return EnableEcommerceRobotUnits && directBuyData?.productQuantities && Object.keys(directBuyData?.productQuantities).length > 0 ;
}
